import { render, staticRenderFns } from "./EducationalGroupStudentAdd.vue?vue&type=template&id=27513c9e&"
import script from "./EducationalGroupStudentAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports